import React from 'react';

function AuditPagination({ page, totalPages, totalCount, onPageChange }) {
    if (!totalPages || totalPages <= 1) return null;

    const getVisiblePages = () => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const result = [];
        if (page <= 4) {
            for (let i = 1; i <= 5; i++) result.push(i);
            result.push('...');
            result.push(totalPages);
        } else if (page >= totalPages - 3) {
            result.push(1);
            result.push('...');
            for (let i = totalPages - 4; i <= totalPages; i++) result.push(i);
        } else {
            result.push(1);
            result.push('...');
            for (let i = page - 1; i <= page + 1; i++) result.push(i);
            result.push('...');
            result.push(totalPages);
        }
        return result;
    };

    const btn = (isActive, isDisabled) => ({
        padding: '5px 11px',
        borderRadius: 4,
        border: `1px solid ${isActive ? '#1b2a4a' : 'var(--ap-border, #dfe3e8)'}`,
        background: isActive ? '#1b2a4a' : 'transparent',
        color: isActive ? '#fff' : isDisabled ? 'var(--ap-text-3, #8492a6)' : 'var(--ap-text-2, #4a5568)',
        fontSize: 11,
        fontWeight: isActive ? 700 : 500,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.4 : 1,
        minWidth: 32,
        textAlign: 'center',
        lineHeight: '1.4',
    });

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, padding: '8px 4px' }}>
            <span style={{ fontSize: 11, color: 'var(--ap-text-3, #8492a6)' }}>
                Page {page} of {totalPages}{totalCount ? ` · ${totalCount} total` : ''}
            </span>
            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <button disabled={page === 1} onClick={() => onPageChange(page - 1)} style={btn(false, page === 1)}>
                    &#8249; Prev
                </button>
                {getVisiblePages().map((p, i) =>
                    p === '...'
                        ? <span key={`e${i}`} style={{ padding: '0 4px', color: 'var(--ap-text-3, #8492a6)', fontSize: 11 }}>…</span>
                        : <button key={p} onClick={() => onPageChange(p)} style={btn(p === page, false)}>{p}</button>
                )}
                <button disabled={page === totalPages} onClick={() => onPageChange(page + 1)} style={btn(false, page === totalPages)}>
                    Next &#8250;
                </button>
            </div>
        </div>
    );
}

export default AuditPagination;
